// @flow

import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material-ui
import { Table, TableBody, TableRow, TableHeader, TableHeaderColumn, TableRowColumn } from 'material-ui/Table';

import BlockListItem from './BlockListItem';
import FlatButton from "material-ui/FlatButton";
import {styles} from "../../lib/styles";
import ContentAdd from "material-ui/svg-icons/content/add";
import {EmptyView} from "../empty-view";

type Props = {
	history: Object,
	location: Object,
	match: Object,
	relay: Object,
	router: Object,
	viewer: Object,
};

type State = {
	currentQuery: ?string,
	pageCursor: number,
	searchText: ?string,
	section: string,
	states: Array<?string>,
	totalPages: number,
};

class BlockList extends React.Component<Props, State> {
	render() {
		const items = this.props.viewer.blocks.edges;
		console.log(items);
		return (
			<section className="wrapper">
				<div className="paper-wrapper" style={{width: '100%'}}>
					<section className="paper paper_main articles">
						<header className="paper-header" style={{alignItems: 'center', justifyContent: 'space-between'}}>
							<h3 className="articles-header--title">
								Рекламные блоки
							</h3>
							<div>
								<FlatButton
									label="Добавить"
									style={{ ...styles.headerButton, marginLeft: 8 }}
									primary
									icon={<ContentAdd />}
									onClick={() => this.props.history.push(`/blocks/new`)}
									labelStyle={{ paddingLeft: 6, paddingRight: 18 }}
								/>
							</div>
						</header>
						{items.length === 0 ? <EmptyView /> : <section className="articles-list">
							<Table className="table articles-table">
								<TableHeader
									displaySelectAll={false}
									adjustForCheckbox={false}
								>
									<TableRow style={{ border: 0 }}>
										<TableHeaderColumn className="table--cell table--cell-th">
											Заголовок
										</TableHeaderColumn>
										<TableHeaderColumn className="table--cell table--cell-th">
											Системное имя
										</TableHeaderColumn>
										<TableHeaderColumn className="table--cell table--cell-th">
											Активный
										</TableHeaderColumn>
										<TableHeaderColumn className="table--cell table--cell-th">
											Кол-во прикрепленных статей
										</TableHeaderColumn>
									</TableRow>
								</TableHeader>
								<TableBody showRowHover stripedRows>
									{items.map((edge) => (
										<BlockListItem
											key={edge.__id}
											block={edge.node}
											router={this.props.router}
											viewer={this.props.viewer}
										/>
									))}
								</TableBody>
							</Table>
						</section>}

					</section>
				</div>
			</section>
		);
	}
}

export default withRouter(createRefetchContainer(
	BlockList,
	graphql`
		fragment BlockList_viewer on Viewer {
			blocks: blocks {
				edges {
					node {
						...BlockListItem_block	
					}
				}
			},
		},
	`,
	graphql`
		query BlockList_Refetch_Query {
			viewer {
				...BlockList_viewer
			}
		}`,
));



// WEBPACK FOOTER //
// src/components/blocks/BlockList.js